export default __webpack_public_path__ + "static/media/draftstars-mycontests.992e667f.svg";